export default __webpack_public_path__ + "static/heart-8e54a953ef91e543e5b9b20380b4405c.svg";